import { LineStyle } from 'lightweight-charts'

const LWC_LINE_STYLE = {
  solid: LineStyle.Solid,
  dashed: LineStyle.Dashed,
  dotted: LineStyle.Dotted,
}

const LINE_OPTS = (point) => ({
  lineWidth: Number.isFinite(point?.lineWidth) ? point.lineWidth : 2,
  lineStyle: LWC_LINE_STYLE[point?.lineStyle] ?? LineStyle.Solid,
  lastValueVisible: false,
  priceLineVisible: false,
  crosshairMarkerVisible: false,
  autoscaleInfoProvider: () => null,
})

// Sin cache de series entre llamadas a propósito: `renderOnPan: false` (ver
// index.js) garantiza que render() solo se invoca en pasadas NO pan-only, y
// ChartPage.jsx/ChartPublicPage.jsx retiran TODAS las series de overlay del
// chart antes de esa pasada (limpieza incondicional, ver "Clean up previous
// overlays" en el efecto de indicadores). Cachear series por debugId aquí
// dejaba referencias zombie tras esa retirada externa: el caché las daba por
// válidas y solo llamaba a setData sobre series ya desenganchadas del chart,
// así que únicamente la última media añadida (la única con debugId nuevo,
// que sí disparaba un addSeries real) llegaba a pintarse — bug real: EMA16 y
// SMA16 coexistían en el estado pero solo una de las dos, la más reciente,
// se veía en el chart. Crear una serie nueva en cada render es correcto aquí
// porque el chart ya llega vacío para este indicador.
export function render(chart, candleSeries, result, config, api) {
  if (!chart || !api) return

  const mas = result?.mas
  if (!Array.isArray(mas) || mas.length === 0) return

  for (const points of mas) {
    if (!Array.isArray(points) || points.length === 0) continue
    const first = points[0]

    const series = api.addSeries(() =>
      chart.addLineSeries({
        color: first?.color || (first?.type === 'sma' ? '#ef4444' : '#f59e0b'),
        ...LINE_OPTS(first),
      })
    )
    if (!series) continue

    const validPoints = points.filter(p => p != null && Number.isFinite(p.time) && Number.isFinite(p.value))
    if (validPoints.length > 0) {
      try { series.setData(validPoints) } catch {}
    }
  }
}
